import { useState } from "react";
import { Lock, Loader2, Send } from "lucide-react";
import { api } from "../../lib/api";

export function ConversationForm({ projectId, isOwner, onSent }: { projectId: string; isOwner: boolean; onSent: () => void }) {
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (message.trim().length < 3) { setErr("Please enter a message with at least 3 characters."); return; }
    setBusy(true); setErr(null);
    try { await api.postQuestionMessage(projectId, message.trim()); setMessage(""); onSent(); }
    catch (error: unknown) { setErr(error instanceof Error ? error.message : "Could not post your message."); }
    finally { setBusy(false); }
  }
  return (
    <form onSubmit={submit} className="border-t border-line pt-3 mt-3">
      <label className="label">{isOwner ? "Reply to participants" : "Send a message"}</label>
      <div className="flex gap-2">
        <input className="field" value={message} onChange={(e) => setMessage(e.target.value)} placeholder={isOwner ? "Reply to the conversation…" : "Ask the project owner…"} />
        <button disabled={busy} className="btn-navy px-3">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}</button>
      </div>
      {err && <p className="text-xs text-brand-red mt-1">{err}</p>}
    </form>
  );
}

export function AwardedConversationNotice({ isOwner, bidStatus }: { isOwner: boolean; bidStatus?: string }) {
  const message = isOwner
    ? "This project has been awarded. Project bidding is closed; continue the agreement in Contracts and Messages."
    : bidStatus === "awarded"
      ? "Your bid was awarded. Project bidding is closed; continue the agreement in Contracts and Messages."
      : bidStatus
        ? "This project was awarded to another bidder. This project conversation is now closed."
        : "This project has been awarded. Project bidding is closed; continue the agreement in Contracts and Messages.";
  return (
    <div className="border border-brand-gold/30 bg-brand-gold/10 rounded-lg px-3 py-2 text-sm text-navy flex gap-2 items-start">
      <Lock className="w-4 h-4 mt-0.5 shrink-0 text-brand-gold" />
      <p>{message}</p>
    </div>
  );
}
